export default "/_next/static/chunks/fonts/MaterialIcons-120b4c7bbd155bd0a04dc37d334baced.ttf";